/**
 * @generated SignedSource<<40c6daf008975a87ae40ec11d6988cd2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRow$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCellsConditionalFormattingOld_rules">;
  readonly " $fragmentType": "IssueRow";
};
export type IssueRow$key = {
  readonly " $data"?: IssueRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "IssueRow",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "condition": "isConditionalFormattingEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "useCellsConditionalFormattingOld_rules"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "032038cd7e5411666d17485db68586e5";

export default node;
